const CARD_ITEMS = [
  {
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20with%20magical%20academy%20scene%2C%20students%20casting%20spells%2C%20warm%20golden%20and%20coral%20colors%2C%20fantasy%20setting%2C%20clean%20cream%20background%2C%20detailed%20character%20design&width=600&height=400&seq=card-01&orientation=landscape',
    tag: '奇幻',
    title: '魔法学院的劣等生',
    desc: '被所有人看不起的F级魔法师，却拥有无人知晓的隐藏力量。逆袭+学院+热血，这部韩漫真的被低估了。',
    stat: '9.2分 · 连载中',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Japanese%20romance%20manga%20illustration%20with%20couple%20at%20sunset%20beach%2C%20warm%20orange%20and%20pink%20tones%2C%20dreamy%20atmosphere%2C%20shojo%20style%2C%20clean%20simple%20background&width=600&height=400&seq=card-02&orientation=landscape',
    tag: '恋爱',
    title: '海边的柠檬汽水',
    desc: '夏天、海边、初恋，一部让人想谈恋爱的纯爱日漫。画风清新到每一格都能当壁纸，治愈力满分。',
    stat: '9.5分 · 完结',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20manhua%20illustration%2C%20ancient%20Chinese%20warrior%20with%20sword%20in%20bamboo%20forest%2C%20warm%20earthy%20tones%2C%20elegant%20ink%20wash%20style%2C%20clean%20cream%20background&width=600&height=400&seq=card-03&orientation=landscape',
    tag: '武侠',
    title: '江湖夜雨十年灯',
    desc: '隐退十年的剑客重出江湖，只为守护最后的正义。国漫武侠新标杆，每一页都是水墨艺术品。',
    stat: '9.4分 · 连载中',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Horror%20thriller%20webtoon%20illustration%20with%20mysterious%20shadow%20figure%20in%20foggy%20alley%2C%20dark%20warm%20sepia%20tones%2C%20suspenseful%20atmosphere%2C%20Korean%20manhwa%20style%2C%20clean%20cream%20background&width=600&height=400&seq=card-04&orientation=landscape',
    tag: '悬疑',
    title: '第七个目击者',
    desc: '六个人目睹了同一场谋杀，但每个人的证词都不一样。烧脑到最后一页的悬疑神作，千万别被剧透。',
    stat: '9.6分 · 连载中',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Comedy%20slice%20of%20life%20manga%20illustration%20with%20office%20workers%20in%20funny%20situations%2C%20warm%20lighthearted%20colors%2C%20Japanese%20manga%20style%2C%20clean%20cream%20background%2C%20expressive%20characters&width=600&height=400&seq=card-05&orientation=landscape',
    tag: '搞笑',
    title: '社畜的漫画日常',
    desc: '打工人看了直呼内行！用搞笑漫画记录社畜生活的酸甜苦辣，每一话都能让人笑出腹肌。',
    stat: '9.0分 · 连载中',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=BL%20romance%20manhwa%20illustration%20with%20two%20handsome%20male%20characters%20in%20elegant%20setting%2C%20warm%20amber%20and%20rose%20tones%2C%20Korean%20webtoon%20style%2C%20delicate%20atmosphere%2C%20clean%20cream%20background&width=600&height=400&seq=card-06&orientation=landscape',
    tag: 'BL',
    title: '星河彼岸',
    desc: '星际背景下的绝美耽美故事，画风精致到每一根发丝都在发光。口碑炸裂的年度BL最佳候选。',
    stat: '9.7分 · 连载中',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            精选推荐
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            编辑团队严选好漫画，每一部都值得你的时间
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {CARD_ITEMS.map((item, i) => (
            <div
              key={i}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-base font-heading font-bold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2">{item.desc}</p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{item.stat}</span>
                  <span className="text-xs text-primary-500 font-medium opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                    开始阅读 <i className="ri-arrow-right-s-line"></i>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}